import Vue from "vue";
import App from "./App.vue";
import "@shared/styles/index.css"; // Global styles including color variables
import vuetify from "./plugins/vuetify"; // see vuetify.js below
import router from "./router";
import store from "./store";
import config from "./config";
import { DialogService } from "@shared/services/dialogService";
import api from "@shared/services/api";

Vue.config.productionTip = false;

// Add config and API to Vue prototype for global access
Vue.prototype.$config = config;
Vue.prototype.$api = api;

// Create the Vue instance
const app = new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount("#app");

// Make router available globally for the dialog service
window.router = router;

// Set the app instance in DialogService for accessing $root
DialogService.setAppInstance(app);
